import { render } from "./PaintSchemeSwatchGroups.vue?vue&type=template&id=05436702&scoped=true"
import script from "./PaintSchemeSwatchGroups.vue?vue&type=script&lang=js"
export * from "./PaintSchemeSwatchGroups.vue?vue&type=script&lang=js"

import "./PaintSchemeSwatchGroups.vue?vue&type=style&index=0&id=05436702&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05436702"]])

export default __exports__